export function WhereMatcher(to) {
  const where = this;
  const redirectTo = where.redirect ?? { name: "home" };
  delete where.redirect;

  if (!where || typeof where !== "object") return false;

  const params = to.params;

  const v = Object.keys(where).reduce((accum, key) => {
    if (!accum) return accum;
    if (where[key] && !params[key]) return false;

    const rule = new RegExp(where[key]);
    return accum && rule.test(params[key]);
  }, true);
  return v ? true : redirectTo;
}
